import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreKeysEnum } from '../../store/store-keys'
import { lpisUserSubjectSearchReducer } from './lpis-user-subject-search/state/lpis-user-subject-search.reducer'
import { LpisUserSubjectSearchEffects } from './lpis-user-subject-search/state/lpis-user-subject-search.effects'
import { mapColorGeneratorReducer } from './common/map-color-generator/state/map-color-generator.reducer'
import { MapColorGeneratorEffects } from './common/map-color-generator/state/map-color-generator.effects'
import { lpisDatasourceReducer } from './lpis-datasource/state/lpis-datasource.reducer'

/**
 * Map State Module
 *
 * Registers NgRx stores and effects used across modules:
 * - MapColorGenerator: used by auth.service (resetColors on login),
 *   general-map services (color generation for layers)
 * - LpisUserSubjectSearch: used by GeneralMapEffects
 * - LpisDatasource: used by general-map.helper
 *
 * Imported globally in AppModule so state is available before
 * MapModule is lazy-loaded.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.LpisUserSubjectSearchComponent, lpisUserSubjectSearchReducer),
        StoreModule.forFeature(StoreKeysEnum.MapColorGenerator, mapColorGeneratorReducer),
        StoreModule.forFeature(StoreKeysEnum.LpisDatasource, lpisDatasourceReducer),
        EffectsModule.forFeature([LpisUserSubjectSearchEffects, MapColorGeneratorEffects]),
    ],
})
export class MapStateModule {}